<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template v-slot:prepend>
        <v-icon icon="mdi-home" size="small"></v-icon>
      </template>
    </v-breadcrumbs>

    <v-container class="grey lighten-5">
      <v-card rounded="xl" elevation="3" class="employee-card p-3">
        <div class="d-flex align-start">
          <v-avatar size="130" border rounded="lg" class="employee-avatar h-100">
            <v-img  src="https://cdn-icons-png.flaticon.com/512/149/149071.png" cover/>
          </v-avatar>
          <div class="ml-4">
            <div class="text-h6 font-weight-bold text-primary">মোঃ হোসেন আলী ফয়জুল</div>
            <div class="d-flex align-center mt-1">
              <v-icon size="16" class="mr-2">mdi-account-tie</v-icon>
              <span class="text-body-2 font-weight-medium">সহকারী প্রোগ্রামার</span>
            </div>
            <div class="d-flex align-center mt-1">
              <v-icon size="16" class="mr-2">mdi-office-building</v-icon>
              <span class="text-body-2">বাংলাদেশ স্থলবন্দর কর্তৃপক্ষ
          </span>
            </div>
            <div class="d-flex align-center mt-2">
              <v-icon size="16" class="mr-2">mdi-email-outline</v-icon>
              <span class="text-body-2">foyzul86@gmail.com</span>
            </div>
            <div class="d-flex align-center mt-1">
              <v-icon size="16" class="mr-2">mdi-phone-outline</v-icon>
              <span class="text-body-2">+8801912345678</span>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>

    <v-container class="grey lighten-5">
      <v-row class="statBox" >
        <v-col  cols="12" sm="6" md="3">
          <v-card class="stat-card stat-primary" rounded="xl" elevation="3">
            <div class="stat-icon">
              <v-icon size="80">mdi-account-group</v-icon>
            </div>
            <v-card-text>
              <div class="text-subtitle-2 text-medium-emphasis">Total Employees</div>
              <div class="text-h4 font-weight-bold mt-2">1,254</div>
              <div class="mt-3 text-body-2">+12% This Month</div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Departments -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card stat-success" rounded="xl" elevation="3">
            <div class="stat-icon">
              <v-icon size="80">mdi-domain</v-icon>
            </div>
            <v-card-text>
              <div class="text-subtitle-2 text-medium-emphasis">Departments</div>
              <div class="text-h4 font-weight-bold mt-2">18</div>
              <div class="mt-3 text-body-2">+3 New Added</div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Attendance -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card stat-warning" rounded="xl" elevation="3">
            <div class="stat-icon">
              <v-icon size="80">mdi-calendar-check</v-icon>
            </div>
            <v-card-text>
              <div class="text-subtitle-2 text-medium-emphasis">Attendance</div>
              <div class="text-h4 font-weight-bold mt-2">92%</div>
              <div class="mt-3 text-body-2">Daily Average</div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Salary -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card stat-danger" rounded="xl" elevation="3">
            <div class="stat-icon">
              <v-icon size="80">mdi-cash-multiple</v-icon>
            </div>
            <v-card-text>
              <div class="text-subtitle-2 text-medium-emphasis">Monthly Salary</div>
              <div class="text-h4 font-weight-bold mt-2">$48K</div>
              <div class="mt-3 text-body-2">+8% Expense</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col cols="12" md="8">
          <BarChart />
        </v-col>
        <v-col cols="12" md="4">
          <PieChart />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col class="eventCalendar" cols="12" md="6">
          <EventCalendar :title="'Update Coming Event'" :height="550" />
        </v-col>
        <v-col class="eventCalendar" cols="12" md="6">
          <v-card rounded="xl" elevation="3">
            <v-card-title class="font-weight-bold">Exam Table</v-card-title>
            <v-divider />
            <v-table class="table-sm">
              <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Calories</th>
                <th class="text-left"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in desserts" :key="item.name">
                <td>{{ item.name }}</td>
                <td>{{ item.calories }}</td>
                <td><span @click="deleteRow()">Delete</span></td>
              </tr>
              </tbody>
            </v-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BarChart from "@/components/shared/BarChart.vue";
import PieChart from "@/components/shared/PieChart.vue";
import EventCalendar from "@/components/shared/EventCalendar.vue";

export default {
  name: 'DashboardComponent',

  components: {EventCalendar, PieChart, BarChart},

  data: () => ({
    rightModal: false,
    breadcrumbs: [
      {
        title: 'Dashboard',
        disabled: true,
        to: '/dashboard',
      }

    ],
    desserts: [
      {
        name: 'Frozen Yogurt',
        calories: 159,
      },
      {
        name: 'Ice cream sandwich',
        calories: 237,
      },
      {
        name: 'Eclair',
        calories: 262,
      },
      {
        name: 'Cupcake',
        calories: 305,
      },
      {
        name: 'Gingerbread',
        calories: 356,
      },
      {
        name: 'Jelly bean',
        calories: 375,
      },
      {
        name: 'Lollipop',
        calories: 392,
      },
      {
        name: 'Honeycomb',
        calories: 408,
      },
      {
        name: 'Donut',
        calories: 452,
      },
      {
        name: 'KitKat',
        calories: 518,
      },
    ],
  }),

  mounted() {
    // console.log(process.env.VUE_APP_NAME)
  },
  methods: {
    async deleteRow () {
      const confirmed = await this.$helpers.confirmAndDelete();
      console.log(confirmed)
    }
  }
}
</script>
